import { ChangeEvent } from 'react'
import uniqBy from 'lodash/uniqBy'
import { useRefCallback } from '@manychat/manyui'

import { FieldSelectEvent } from 'common/fields/linking/components/interfaces/fieldEvents'
import { Tag } from 'common/tags/type'

import { InitialMigrateStepContentProps, TagOption } from './interfaces'

export function useInitialStep(props: InitialMigrateStepContentProps) {
  const handleChange: InitialMigrateStepContentProps['onChange'] = useRefCallback((data) => {
    const { onChange, ...rest } = props

    onChange({ ...rest, ...data })
  })

  const handleTagChange = useRefCallback(({ target }: { target: TagOption }) => {
    const { tags } = props

    handleChange({ tags: uniqBy([...tags, target], 'value') })
  })

  const handleCUFChange = useRefCallback(({ target: { value } }: FieldSelectEvent) => {
    handleChange({ cufId: value })
  })

  const handleSFChange = useRefCallback(({ target: { value } }: FieldSelectEvent) => {
    handleChange({ sfName: value })
  })

  const clearCUFValue = useRefCallback(() => {
    handleChange({ cufId: null })
  })

  const clearSFValue = useRefCallback(() => {
    handleChange({ sfName: null })
  })

  const handleOverwriteChange = useRefCallback(({ target }: ChangeEvent<HTMLInputElement>) => {
    handleChange({ overwrite: target.checked })
  })

  const handleDeleteTag = useRefCallback((tagId: Tag['id']) => {
    const { tags } = props
    const nextTags = tags.filter((tag) => tag.value !== tagId)

    handleChange({ tags: nextTags })
  })

  return {
    handleTagChange,
    handleCUFChange,
    handleSFChange,
    clearCUFValue,
    clearSFValue,
    handleOverwriteChange,
    handleDeleteTag,
  }
}
